import loadable from "@loadable/component";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";

const ProfileDesktop = loadable(() => import("./ProfileDesktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <ProfileDesktop {...props} />
  </ErrorBoundary>
);
